import React from 'react';

export default function TeamSection({ content }) {
  const { title, subtitle, members } = content || {};

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{title || 'Tim Kami'}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{subtitle || 'Orang-orang hebat di balik Klinnovac'}</p>
        </div>
        {(members || []).length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8">
            {(members || []).map((member, i) => (
              <div key={i} className="text-center group">
                <div className="relative w-32 h-32 mx-auto mb-4">
                  <div className="w-full h-full bg-gradient-to-br from-primary/20 to-accent/20 rounded-full flex items-center justify-center text-4xl shadow-md group-hover:shadow-xl transition-shadow">
                    {member.image_url ? (
                      <img src={member.image_url} alt={member.name} className="w-full h-full rounded-full object-cover" />
                    ) : (
                      <span>{member.avatar || '👤'}</span>
                    )}
                  </div>
                </div>
                <h3 className="font-bold text-gray-900">{member.name}</h3>
                <p className="text-sm text-primary font-medium">{member.position}</p>
                {member.bio && <p className="text-xs text-gray-500 mt-2 leading-relaxed">{member.bio}</p>}
                {member.social && (
                  <div className="flex justify-center gap-3 mt-3">
                    {Object.entries(member.social).map(([platform, url]) => (
                      <a key={platform} href={url} className="text-gray-400 hover:text-primary transition-colors text-sm" target="_blank" rel="noopener noreferrer">{platform}</a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-400 py-12">Tim akan ditampilkan di sini</div>
        )}
      </div>
    </section>
  );
}